const STATUS_TEXT = require('../../modules/config.json').processes;

const state = {
  status: 0,
  outerServiceStatus: {
    posServer: false,
    posBox: false,
    nccc: false,
  },
  localDeviceStatus: {
    qrCodeReader: false,
    printer: false,
    cardReader: false,
  },
  language: 'zh_TW', // zh_TW en_US
};

const mutations = {
  SET_STATUS(state, content) {
    state.status = content;
  },
  INCREMENT_STATUS(state) {
    state.status += 1;
  },
  SET_OUTER_SERVICE_STATUS(state, content) {
    state.outerServiceStatus[content.host] = content.status;
  },
  SET_LOCAL_DEVICE_STATUS(state, content) {
    state.localDeviceStatus[content.device] = content.status;
  },
  SET_LANGUAGE(state, content) {
    state.language = content;
  },
};

const actions = {
  setStatus({ commit }, statusText) {
    const statusCode = STATUS_TEXT.indexOf(statusText);
    if (statusCode > -1) {
      commit('SET_STATUS', statusCode);
    }
  },
  statusIncrement({ commit }) {
    commit('INCREMENT_STATUS');
  },
  setOuterServiceStatus({ commit }, connInfo) {
    if (connInfo.host && connInfo.status) {
      commit('SET_OUTER_SERVICE_STATUS', connInfo);
    }
  },
  setLocalDeviceStatus({ commit }, deviceInfo) {
    return new Promise((resolve) => {
      if (deviceInfo.device) {
        commit('SET_LOCAL_DEVICE_STATUS', deviceInfo);
        resolve();
      }
    });
  },
  setLanguage({ commit }, language) {
    if (language) {
      commit('SET_LANGUAGE', language);
    }
  },
};

const getters = {
  statusText: (state) => STATUS_TEXT[state.status],
  nextStatusText: (state) => STATUS_TEXT[state.status + 1],
  deviceStatus: (state) => state.localDeviceStatus,
  language: (state) => state.language,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
